import { ErrorsInterface } from './../index';
import { DataProvider } from '@/types';

export interface AudienceState {
  audience: Audience;
  audiencesList: DataProvider;
  pixels: Array<Pixel>;
  siteTimes: DataProvider;
  isSavingForm: boolean;
}

export interface Audience {
  name: string;
  source: string;
  pixelIds: Array<string | number | undefined>;
  siteTimeId: number | string | null;
  fromDate: string | null;
  toDate: string | null;
  fileName: string | null;
  fileData: Blob | null;
  errors: ErrorsInterface;
}

export interface AudienceStatistics {
  id: number;
  name: string;
  cover: number | null;
  size: number | null;
  pixel: Pixel | null;
}

export interface Pixel {
  id: number;
  name: string;
  public_key: string;
}

export enum ESource {
  VISITORS = 'visitors',
  CUSTOMERS = 'customers',
}
